import themeConfig from '@/../themeConfig'
export interface ThemeState {
    theme: string
    isSidebarActive: boolean
    isSidebarReduced: boolean
    sidebarWidth: string
    themeColor: string

}
export default {
    namespaced: true,
    state: {
        theme: themeConfig.theme,
        isSidebarActive: false,
        isSidebarReduced: themeConfig.sidebarCollapsed,
        sidebarWidth: "default",
        themeColor: themeConfig.themeColor
    } as ThemeState,
    getters: {

    },
    mutations: {
        IS_SIDEBAR_ACTIVE(state, isActive: boolean) {
            state.isSidebarActive = isActive;
        },
        TOGGLE_REDUCE_SIDEBAR(state, isReduced: boolean) {
            state.isSidebarReduced = isReduced;
        },
        SET_THEME(state, themeName: string) {
            state.theme = themeName;
        },
        SET_THEME_COLOR(state, color: string) {
            state.themeColor = color;
        },
        SET_SIDEBAR_WIDTH(state, width:string) {
            state.sidebarWidth = width;
        },
    },
    actions: {
        updateSidebarWidth({ commit }, payload: {width: string}) {
            commit('SET_SIDEBAR_WIDTH', payload.width);
        },
        /*
        async loadName({ commit }, payload: { id: string }) {
            const name = `Name-${payload.id}` // load it from somewhere
            commit("SET_NAME", name)
            return { name }
        },*/
    }
} as const;
